{{#if is_default}}
--
{{else}}
{{#EACH-COLS settings 1 'ct-access-rights'}}
{{#COMPARE id "!=" "1301"}} {{! hide remote control element }}
	<i class="m-r-5 text-success fa {{#if readOnly}}fa-eye{{else}}fa-check{{/if}}"></i>&nbsp;{{name}}
{{/COMPARE}}
{{/EACH-COLS}}
{{#unless settings}}{{TR 'alles'}}{{/unless}}
{{/if}}
